export const nameSuffixes = [
  { value: 'Mr', name: 'Mr' },
  { value: 'Miss', name: 'Miss' },
  { value: 'Mrs', name: 'Mrs' },
  { value: 'Shri', name: 'Shri' },
  { value: 'Smt', name: 'Smt' },
  { value: 'Dr', name: 'Dr' },
]

export const countryCodes = [
  { value: '91', name: '+91' },
  { value: '0', name: '+0' },
]

export const feeTypes = [
  { value: 1, name: 'Yearly' },
  { value: 2, name: 'Monthly' },
  { value: 3, name: 'Quarterly' },
  { value: 4, name: 'Half yearly' },
  { value: 5, name: '4 Months' },
  { value: 6, name: '2 Months' },
]

export const genderTypes = [
  { value: 'M', name: 'Male' },
  { value: 'F', name: 'Female' },
  { value: 'O', name: 'Other' },
]

export const categoryTypes = [
  { value: 'GEN', name: 'General' },
  { value: 'ST', name: 'ST' },
  { value: 'SC', name: 'SC' },
  { value: 'OBC', name: 'OBC' },
  { value: 'OTHERS', name: 'Others' },
]

export const bloodGroups = [
  { value: 'A+', name: 'A+' },
  { value: 'A-', name: 'A-' },
  { value: 'B+', name: 'B+' },
  { value: 'B-', name: 'B-' },
  { value: 'AB+', name: 'AB+' },
  { value: 'AB-', name: 'AB-' },
  { value: 'O+', name: 'O+' },
  { value: 'O-', name: 'O-' },
]

export const qualifications = [
  { value: 'BG', name: 'Below Graduation' },
  { value: 'GD', name: 'Graduate' },
  { value: 'PG', name: 'Post Graduate' },
  { value: 'DR', name: 'Doctorate' },
  { value: 'O', name: 'Others' },
]

export const occupations = [
  { value: 'SV', name: 'Service' },
  { value: 'PSU', name: 'PSU Employee' },
  { value: 'BU', name: 'Business' },
  { value: 'SE', name: 'Self Employed' },
  { value: 'GE', name: 'Govt. Employee' },
  { value: 'UN', name: 'Unemployed' },
]

export const idTypes = [
  { value: 'AAD', name: 'Aadhaar' },
  { value: 'PAN', name: 'Pan Card' },
  { value: 'PP', name: 'Passport' },
  { value: 'EPIC', name: 'Electoral Photo Identity Card' },
  { value: 'EMP', name: 'Employee Card' },
]

export const eventTypes = [
  { value: 'F', name: 'Function' },
  { value: 'H', name: 'Holiday' },
  { value: 'N', name: 'Normal' },
  { value: 'E', name: 'Exam' },
  { value: 'O', name: 'Others' },
]

export const targetAudianceTypes = [
  { value: 0, name: 'All' },
  { value: 1, name: 'Parents' },
  { value: 2, name: 'Teachers / Staffs' },
  { value: 3, name: 'Parents & Teachers' },
  { value: 4, name: 'Students' },
]

export const monthsOfYear = [
  { value: '01', name: 'January' },
  { value: '02', name: 'Febuary' },
  { value: '03', name: 'March' },
  { value: '04', name: 'April' },
  { value: '05', name: 'May' },
  { value: '06', name: 'June' },
  { value: '07', name: 'July' },
  { value: '08', name: 'August' },
  { value: '09', name: 'September' },
  { value: '10', name: 'October' },
  { value: '11', name: 'November' },
  { value: '12', name: 'December' },
]

export const workingWeekDays = [
  { value: 'MON', name: 'MON' },
  { value: 'TUE', name: 'TUE' },
  { value: 'WED', name: 'WED' },
  { value: 'THU', name: 'THU' },
  { value: 'FRI', name: 'FRI' },
  { value: 'SAT', name: 'SAT' },
]

export const paymentTypes = [
  { value: 0, name: 'Cash' },
  { value: 1, name: 'Cheque' },
  { value: 2, name: 'Bank Deposit' },
  { value: 3, name: 'Online' },
]

export const onlineApplicationPaymentModes = [
  { value: 1, name: 'Online' },
  { value: 2, name: 'Offline' },
]

export const onlineApplicantFormStatus = {
  0: 'Incomplete',
  1: 'Completed',
  3: 'Submitted',
}

export const onlineApplicantStatus = {
  0: 'Pending',
  1: 'Rejected',
  2: 'Approved',
  3: 'Admittted',
}

export const onlineExamTypes = [
  { value: 0, name: 'Normal' },
  { value: 1, name: 'JEE' },
  { value: 2, name: 'NEET' },
]

export const afterOnlineExamOptions = [
  { value: 0, name: 'Do nothing' },
  { value: 1, name: 'Show only score' },
  { value: 2, name: 'Show preview' },
]

export const onlineExamStatus = [
  { value: 0, name: 'Cancelled' },
  { value: 1, name: 'Pending' },
  { value: 2, name: 'Published' },
  { value: 3, name: 'Declared' },
  { value: 4, name: 'Declare Pending' },
]

export const scheduleType = [
  { value: 0, name: 'Fixed' },
  { value: 1, name: 'Flexible' },
]

export const lateFeeFineMode = [
  { value: null, name: '' },
  { value: 0, name: '' },
  { value: 1, name: 'Fixed' },
  { value: 2, name: 'Daily Increment' },
  { value: 3, name: 'Weekly Increment' },
  { value: 4, name: 'Monthly Increment' },
  { value: 5, name: 'Quarterly Increment' },
]

export const lateFeeFineType = [
  { value: null, name: '' },
  { value: 1, name: 'Amount' },
  { value: 2, name: 'Percentage' },
]

export const hostelTypes = [
  { value: 'BOYS', name: 'BOYS' },
  { value: 'GIRLS', name: 'GIRLS' },
  { value: 'OTHERS', name: 'OTHERS' },
]

export const facilitiesStatus = [
  { value: 'Available', name: 'Available' },
  { value: 'Out of Service', name: 'Out of Service' },
  { value: 'Under Maintenance', name: 'Under Maintenance' },
]

export const roomTypes = [
  { value: 'Single', name: 'Single' },
  { value: 'Double', name: 'Double' },
  { value: 'Suite', name: 'Suite' },
  { value: 'Shared Room', name: 'Shared Room' },
]

export const roomStatus = [
  { value: 'Available', name: 'Available' },
  { value: 'Occupied', name: 'Occupied' },
]

export const includeFields = [
  {
    title: 'Exit Type',
    dataIndex: 'exit_type',
    key: 'exit_type',
  },
  {
    title: 'Exit Reason',
    dataIndex: 'exit_reason',
    key: 'exit_reason',
  },
]
